module.exports = __webpack_public_path__ + "static/media/256681.94662bde.jpg";